import styled from 'styled-components';

export const EventContainer = styled.div`
  padding: ${({ theme }) => theme.spacing(0.25)};
`;
